import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const getCompanies = async () => {
  try {
    const resp = await apiClient.get(`/users/getAllCompanies`);

    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
